<template>
  <div class="home-page">
    <!-- 英雄区域 -->
    <section class="py-16 md:py-24 bg-neutral-100">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex flex-col md:flex-row items-center">
          <div class="md:w-1/2 mb-10 md:mb-0">
            <h1 class="text-3xl md:text-5xl font-bold leading-tight mb-6">
              发现与分享<span class="text-primary">AI生成</span>的创意工具
            </h1>
            <p class="text-lg text-neutral-500 mb-8 max-w-lg">
              汇聚开发者使用AI技术创建的各类实用小工具，从图片处理到文本生成，应有尽有。
            </p>
            <div
              class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
            >
              <router-link
                to="/explore"
                class="px-6 py-3 rounded-md bg-primary text-white font-medium hover:bg-primary/90 apple-transition shadow-sm text-center"
              >
                探索工具
              </router-link>
              <div
                @click="checkLogin('/submit')"
                class="cursor-pointer px-6 py-3 rounded-md bg-white text-primary border border-primary font-medium hover:bg-neutral-50 apple-transition text-center"
              >
                发布工具
              </div>
            </div>
          </div>
          <div class="md:w-1/2">
            <div class="relative">
              <img
                src="https://picsum.photos/id/180/600/400"
                alt="AI工具展示"
                class="w-full h-auto rounded-xl shadow-lg hover-lift"
              />
              <div class="absolute top-4 left-4">
                <span
                  class="px-3 py-1 bg-secondary text-white text-xs rounded-full"
                  >热门工具</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 工具展示区域 -->
    <section id="explore" class="py-16 bg-white">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div
          class="flex flex-col md:flex-row justify-between items-start md:items-center mb-10"
        >
          <div>
            <h2 class="text-2xl md:text-3xl font-bold mb-2">热门AI工具</h2>
            <p class="text-neutral-500">由社区创建和推荐的最受欢迎的AI小工具</p>
          </div>
          <div class="mt-4 md:mt-0 flex space-x-2">
            <button
              @click="getToolsList('lastest')"
              :class="[
                'px-4 py-2 rounded-md text-sm font-medium apple-transition',
                currentFilter === 'lastest'
                  ? 'bg-primary text-white'
                  : 'bg-white border border-neutral-300 hover:border-primary hover:text-primary',
              ]"
            >
              最新
            </button>
            <button
              @click="getToolsList('popular')"
              :class="[
                'px-4 py-2 rounded-md text-sm font-medium apple-transition',
                currentFilter === 'popular'
                  ? 'bg-primary text-white'
                  : 'bg-white border border-neutral-300 hover:border-primary hover:text-primary',
              ]"
            >
              最受欢迎
            </button>
            <button
              @click="getToolsList('rating')"
              :class="[
                'px-4 py-2 rounded-md text-sm font-medium apple-transition',
                currentFilter === 'rating'
                  ? 'bg-primary text-white'
                  : 'bg-white border border-neutral-300 hover:border-primary hover:text-primary',
              ]"
            >
              评分最高
            </button>
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div
            v-for="tool in toolList"
            :key="tool.id"
            class="bg-white rounded-xl overflow-hidden border border-neutral-200 hover-lift tool-card cursor-pointer"
            @click="openToolDetail(tool)"
          >
            <div class="relative h-48 overflow-hidden group">
              <img
                :src="tool.cover"
                :alt="tool.title"
                class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div class="absolute top-4 left-4">
                <span
                  class="px-3 py-1 bg-primary text-white text-xs rounded-full"
                  >{{ getCategoryName(tool.categoryid) }}</span
                >
                <span
                  v-if="getSubName(tool.subid).length > 0"
                  class="px-3 py-1 ml-2 bg-green-700 text-white text-xs rounded-full"
                  >{{ getSubName(tool.subid) }}</span
                >
              </div>
              <button
                @click.stop="favAction(tool)"
                class="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/80 backdrop-blur-sm flex items-center justify-center hover:bg-white apple-transition favorite-btn"
              >
                <i
                  v-if="tool.isFav"
                  class="fa fa-heart text-red-500 apple-transition"
                ></i>
                <i
                  v-else
                  class="fa fa-heart-o text-neutral-600 apple-transition"
                ></i>
              </button>
            </div>
            <div class="p-5">
              <h3 class="text-lg font-bold mb-2">{{ tool.title }}</h3>
              <p class="text-neutral-500 text-sm mb-4 line-clamp-2 h-10">
                {{ tool.description }}
              </p>
              <div class="flex justify-between items-center">
                <div class="flex items-center">
                  <img
                    :src="tool.avatar"
                    alt="头像"
                    class="w-6 h-6 rounded-full mr-2"
                  />
                  <span class="text-xs text-neutral-500">{{ tool.uname }}</span>
                </div>
                <div class="flex items-center space-x-3">
                  <span class="text-xs text-neutral-500"
                    ><i class="fa fa-download mr-1"></i>
                    {{ tool.downloadCount }}</span
                  >
                  <span class="text-xs text-neutral-500"
                    ><i class="fa fa-star text-yellow-400 mr-1"></i>
                    {{ tool.rate }}</span
                  >
                </div>
              </div>

              <div class="mt-4 flex space-x-3">
                <button
                  @click.stop="downloadAction(tool)"
                  class="flex-1 px-3 py-2 bg-primary text-white text-sm rounded-md hover:bg-primary/90 apple-transition download-btn"
                >
                  <i class="fa fa-download mr-1"></i> 下载 (-2积分)
                </button>
                <button
                  @click.stop="zanAction(tool)"
                  class="w-9 h-9 border border-neutral-300 rounded-md flex items-center justify-center hover:border-primary hover:text-primary apple-transition like-btn"
                >
                  <i v-if="!tool.isZan" class="fa fa-thumbs-o-up"></i>
                  <i v-else class="fa fa-thumbs-up text-blue-500"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mt-10">
          <router-link
            to="/explore"
            class="inline-block px-6 py-3 rounded-md bg-white border border-neutral-300 text-neutral-700 font-medium hover:border-primary hover:text-primary apple-transition"
          >
            加载更多 <i class="fa fa-chevron-down ml-1"></i>
          </router-link>
        </div>
      </div>
    </section>

    <!-- 分类区域 -->
    <section
      id="categories"
      class="py-16 bg-neutral-100"
      v-if="categoryList && categoryList.length > 0"
    >
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-12">
          <h2 class="text-2xl md:text-3xl font-bold mb-4">按分类浏览</h2>
          <p class="text-neutral-500 max-w-2xl mx-auto">
            探索不同类别的AI工具，找到你需要的创意解决方案
          </p>
        </div>

        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4">
          <router-link
            v-for="category in categoryList.slice(0, 6)"
            :key="category.id"
            :to="{ path: '/categories', query: { category: category.id } }"
            class="category-card bg-white rounded-xl p-5 text-center border border-neutral-200 hover-lift"
          >
            <div
              class="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3"
              :style="{
                backgroundColor: category.color + '20',
              }"
            >
              <i
                :class="['fa', category.icon, 'text-xl']"
                :style="{ color: category.color }"
              ></i>
            </div>
            <h3 class="font-medium text-sm">{{ category.title }}</h3>
            <p class="text-xs text-neutral-500 mt-1">
              {{ category.toolCount }} 个工具
            </p>
          </router-link>
        </div>

        <div class="text-center mt-8">
          <router-link
            to="/categories"
            class="text-primary font-medium hover:underline"
          >
            查看所有分类 <i class="fa fa-arrow-right ml-1"></i>
          </router-link>
        </div>
      </div>
    </section>

    <!-- 学科区域 -->
    <section
      id="subjects"
      class="py-16 bg-white"
      v-if="subList && subList.length > 0"
    >
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-12">
          <h2 class="text-2xl md:text-3xl font-bold mb-4">按学科浏览</h2>
          <p class="text-neutral-500 max-w-2xl mx-auto">
            探索不同学科领域的AI工具，辅助您的学习与研究
          </p>
        </div>

        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          <router-link
            v-for="subject in subList.slice(0, 12)"
            :key="subject.id"
            :to="{ path: '/subjects', query: { subject: subject.id } }"
            class="group bg-neutral-50 rounded-lg p-4 text-center border border-neutral-200 hover:border-primary hover:shadow-sm transition-all duration-300"
          >
            <h3 class="font-medium text-sm group-hover:text-primary transition-colors">{{ subject.title }}</h3>
            <!-- <p class="text-xs text-neutral-500 mt-1">
              {{ subject.toolCount || 0 }} 个工具
            </p> -->
          </router-link>
        </div>

        <div class="text-center mt-8">
          <router-link
            to="/subjects"
            class="text-primary font-medium hover:underline"
          >
            查看所有学科 <i class="fa fa-arrow-right ml-1"></i>
          </router-link>
        </div>
      </div>
    </section>

    <!-- 排行榜区域 -->
    <section id="leaderboard" class="py-16 bg-white">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-12">
          <h2 class="text-2xl md:text-3xl font-bold mb-4">工具排行榜</h2>
          <p class="text-neutral-500 max-w-2xl mx-auto">
            最受欢迎和评分最高的AI工具
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <!-- 热门下载排行榜 -->
          <div class="bg-neutral-100 rounded-xl p-6">
            <div class="flex items-center justify-between mb-6">
              <h3 class="text-xl font-bold">热门下载</h3>
              <router-link
                to="/rankings"
                class="px-3 py-1 bg-primary/10 text-primary text-xs rounded-full hover:bg-primary/20 transition-colors"
                >查看全部</router-link
              >
            </div>

            <div class="space-y-4">
              <div
                v-for="(tool, index) in rankDownloadList"
                :key="tool.id"
                class="flex items-center p-3 bg-white rounded-lg border border-neutral-200 hover:shadow-md transition-shadow cursor-pointer"
                @click="openToolDetail(tool)"
              >
                <div
                  :class="[
                    'w-8 h-8 rounded-full flex items-center justify-center font-bold mr-4 text-white',
                    index === 0
                      ? 'bg-primary'
                      : index === 1
                      ? 'bg-neutral-400'
                      : 'bg-neutral-300',
                  ]"
                >
                  {{ index + 1 }}
                </div>
                <img
                  :src="tool.cover"
                  :alt="tool.title"
                  class="w-12 h-12 rounded-lg object-cover mr-4"
                />
                <div class="flex-1 min-w-0">
                  <h4 class="font-medium truncate">{{ tool.title }}</h4>
                  <p class="text-xs text-neutral-500">
                    {{ getCategoryName(tool.categoryid) }} ·
                    <span v-if="getSubName(tool.subid).length > 0">{{
                      getSubName(tool.subid)
                    }} · </span>
                    {{ formatNumber(tool.monthDownloadCount) }} 下载
                  </p>
                </div>
                <div class="flex items-center">
                  <i class="fa fa-download text-stone-400 mr-1"></i>
                  <span>{{ tool.monthDownloadCount }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 最高评分排行榜 -->
          <div class="bg-neutral-100 rounded-xl p-6">
            <div class="flex items-center justify-between mb-6">
              <h3 class="text-xl font-bold">最高评分</h3>
              <router-link
                to="/rankings"
                class="px-3 py-1 bg-secondary/10 text-secondary text-xs rounded-full hover:bg-secondary/20 transition-colors"
                >查看全部</router-link
              >
            </div>

            <div class="space-y-4">
              <div
                v-for="(tool, index) in topRatedTools"
                :key="tool.id"
                class="flex items-center p-3 bg-white rounded-lg border border-neutral-200 hover:shadow-md transition-shadow cursor-pointer"
                @click="openToolDetail(tool)"
              >
                <div
                  :class="[
                    'w-8 h-8 rounded-full flex items-center justify-center font-bold mr-4 text-white',
                    index === 0
                      ? 'bg-secondary'
                      : index === 1
                      ? 'bg-neutral-400'
                      : 'bg-neutral-300',
                  ]"
                >
                  {{ index + 1 }}
                </div>
                <img
                  :src="tool.cover"
                  :alt="tool.title"
                  class="w-12 h-12 rounded-lg object-cover mr-4"
                />
                <div class="flex-1 min-w-0">
                  <h4 class="font-medium truncate">{{ tool.title }}</h4>
                  <p class="text-xs text-neutral-500">
                    {{ getCategoryName(tool.categoryid) }} ·
                     <span v-if="getSubName(tool.subid).length > 0">{{
                      getSubName(tool.subid)
                    }} · </span>
                    {{ formatNumber(tool.downloadCount) }} 下载
                  </p>
                </div>
                <div class="flex items-center">
                  <i class="fa fa-star text-yellow-400 mr-1"></i>
                  <span>{{ tool.rate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import index from "./index.js";
export default index;
</script>
